/**
 * Where the centre can be reached, in the forms the UI needs.
 *
 * The phone number is operator-configurable through REACT_APP_CONTACT_PHONE,
 * so it is normalised here once rather than formatted at each call site.
 *
 * @module shared/utils/contactInfo
 */

const DEFAULT_CONTACT_PHONE_RAW = '0987980417';

const normalizeContactRaw = (): string => {
  const fromEnv = (process.env.REACT_APP_CONTACT_PHONE || '').replace(/[^\d+]/g, '');
  return (fromEnv || DEFAULT_CONTACT_PHONE_RAW).replace(/[^\d+]/g, '');
};

/** Visible label (Vietnamese 0xxx spacing when 10 digits). */
export const getContactPhoneDisplayLabel = (): string => {
  const raw = normalizeContactRaw();
  const digits = raw.startsWith('+') ? raw.slice(1) : raw;
  const d = digits.replace(/\D/g, '');
  if (d.length === 10 && d.startsWith('0')) {
    return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`;
  }
  return d || DEFAULT_CONTACT_PHONE_RAW;
};

/** `tel:` href in E.164 so it dials correctly from abroad too. */
export const getContactTelHref = (): string => {
  const raw = normalizeContactRaw();
  if (raw.startsWith('+')) return `tel:${raw}`;
  const digits = raw.replace(/\D/g, '');
  if (digits.startsWith('84')) return `tel:+${digits}`;
  if (digits.startsWith('0')) return `tel:+84${digits.slice(1)}`;
  return `tel:+84${digits}`;
};

/** Where applications are received — resolved from the Google Maps short URL. */
export const APPLICATION_MAP_EMBED_SRC =
  'https://www.google.com/maps?q=13.999262%2C109.0677072&z=17&hl=vi&output=embed';

export const APPLICATION_MAP_DIRECTIONS_URL = 'https://maps.app.goo.gl/DGV6Sn3ioU4rciWw8';

export const CONTACT_EMAIL = 'khavy1203@gmail.com';

/** Trang Facebook chính thức của trung tâm. */
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61590281201977';

/** Nhắn tin Zalo cho trung tâm. Cùng số với nút gọi, chỉ khác kênh. */
export const getZaloChatUrl = (): string => {
  const digits = normalizeContactRaw().replace(/\D/g, '');
  // zalo.me nhận số nội địa 0xxx; số đã ở dạng 84… phải đổi lại.
  const local = digits.startsWith('84') ? `0${digits.slice(2)}` : digits;
  return `https://zalo.me/${local || DEFAULT_CONTACT_PHONE_RAW}`;
};
